import { useState } from "react";
import { ListChecks, Flag, Users } from "lucide-react";
import AdminGate from "@/components/AdminGate";
import Review from "@/pages/Review";
import Reports from "@/pages/Reports";
import UserRoster from "@/components/UserRoster";

const tabs = [
  { id: "review", label: "Review Console", icon: ListChecks, testId: "admin-tab-review" },
  { id: "reports", label: "Reports Inbox", icon: Flag, testId: "admin-tab-reports" },
  { id: "users", label: "Users", icon: Users, testId: "admin-tab-users" },
];

const AdminPage = () => {
  const [activeTab, setActiveTab] = useState("review");

  return (
    <AdminGate>
      <div className="max-w-7xl mx-auto px-6 pt-8 md:px-12" data-testid="admin-page">
        <div className="flex items-center gap-3 border-b border-white/10 pb-0">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              data-testid={tab.testId}
              className={`flex items-center gap-2 px-5 py-3 font-headings text-sm uppercase tracking-[0.2em] border-b-2 transition-all -mb-px ${
                activeTab === tab.id
                  ? "border-[#FFE800] text-[#FFE800]"
                  : "border-transparent text-gray-400 hover:text-[#FFE800]/70"
              }`}
            >
              <tab.icon className="h-4 w-4" />
              {tab.label}
            </button>
          ))}
        </div>
      </div>
      {activeTab === "review" && <Review embedded />}
      {activeTab === "reports" && <Reports embedded />}
      {activeTab === "users" && (
        <div className="max-w-7xl mx-auto px-6 py-8 md:px-12">
          <UserRoster />
        </div>
      )}
    </AdminGate>
  );
};

export default AdminPage;
